import { NavButtonLabel } from 'types/Labels';

/**
 * The default ARIA label for previous month button in navigation
 */
export const labelPrevious: NavButtonLabel = (): string => {
  return 'Go to previous month';
};
